export const getSafeAreaTop = () =>
  parseInt(getComputedStyle(document.documentElement).getPropertyValue('--sat'))
